import { App } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart, RadarChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GraphicComponent,
} from 'echarts/components';
import AddCustomerDrawer from './common/Drawers/AddCustomerDrawer/index.vue';
import ReportDrawer from './common/Drawers/ReportDrawer/index.vue';
import Chart from './chart/index.vue';
import Breadcrumb from './breadcrumb/index.vue';
import LogoutConfirm from './logout-confirm/index.vue';
import FollowUpPlanModal from './follow-up-plan-modal/index.vue';
import FollowUpRecordDrawer from './follow-up-record-drawer/index.vue';
import FollowUpRecordModal from './follow-up-record-modal/index.vue';
import CustomerDrawer from './common/Drawers/CustomerDrawer/index.vue';
import ReportMsgDrawer from './common/Drawers/ReportMsgDrawer/index.vue';

// Manually introduce ECharts modules to reduce packing size

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  RadarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GraphicComponent,
]);

const install = (app: App) => {
  app.component('Chart', Chart);
  app.component('Breadcrumb', Breadcrumb);
  app.component('LogoutConfirm', LogoutConfirm);
  app.component('FollowUpPlanModal', FollowUpPlanModal);
  app.component('FollowUpRecordDrawer', FollowUpRecordDrawer);
  app.component('FollowUpRecordModal', FollowUpRecordModal);
  app.component('ReportDrawer', ReportDrawer);
  app.component('CustomerDrawer', CustomerDrawer);
  app.component('AddCustomerDrawer', AddCustomerDrawer);
  app.component('ReportMsgDrawer', ReportMsgDrawer);
};

export {
  Chart,
  Breadcrumb,
  ReportDrawer,
  LogoutConfirm,
  FollowUpPlanModal,
  FollowUpRecordDrawer,
  FollowUpRecordModal,
  CustomerDrawer,
  AddCustomerDrawer,
  ReportMsgDrawer,
};
export default { install };
